export default function validateEmail() {
  const accessTokenElement = document.querySelector(
    'meta[name="cobot:access-token"]',
  );
  if (!accessTokenElement) return;

  document
    .querySelector('[data-new-user-email]')
    .addEventListener('blur', async (e) => {
      if (!e.target.value.length) return;
      checkIfEmailExists(e.target.value, accessTokenElement);
    });
}

export async function checkIfEmailExists(email, accessTokenElement) {
  const isEmailValid = email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
  const invalidEmailElement = document.querySelector(
    '[data-invalid-email-message]',
  );
  const errorElement = document.querySelector('[data-new-user-email-error]');
  const successCheckmark = document.querySelector('#email-preview-success');
  // hide error
  addHiddenClass(errorElement);
  // hide email invalid message
  addHiddenClass(invalidEmailElement);
  // hide success checkmark
  addHiddenClass(successCheckmark);
  if (!isEmailValid) {
    removeHiddenClass(invalidEmailElement);
    return false;
  }
  const accessToken = accessTokenElement.content;
  const emailPreviewResponse = await getEmailPreview(accessToken, email);
  if (emailPreviewResponse.status === 409) {
    const response = await emailPreviewResponse.json();
    errorElement.innerText = response.errors[0].detail;
    // show error
    removeHiddenClass(errorElement);
  } else {
    // show success checkmark
    removeHiddenClass(successCheckmark);
  }
}

async function getEmailPreview(accessToken, email) {
  const data = {
    data: {
      type: 'userEmailPreviews',
      attributes: {
        email,
      },
    },
  };
  return await fetch(
    `//${location.host.replace('www.', 'api.')}/user_email_preview`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/vnd.api+json',
      },
      body: JSON.stringify(data),
    },
  );
}

export function removeHiddenClass(element) {
  element.classList.remove('hidden');
}
export function addHiddenClass(element) {
  element.classList.add('hidden');
}
